import React, { useState, useEffect } from "react";
import useRouter from "hooks/useRouter";
import useSearch from "redux/hooks/useSearch";
import { StrainCard } from "@leafly-com/frontend-components";
import { Action, Category, trackEvent } from "utils/trackEvent";
import PhenotypeCarousel from "components/PhenotypeCarousel";

const StrainResults: React.FC = () => {
  const ITEMS_PER_LOAD = 6;

  const {
    parsedQuery: { q, searchCategory },
  } = useRouter();
  const { strain: strains, loadMoreSearchResults } = useSearch();

  const viewingCountOnLoad = searchCategory === "strain" ? 12 : 3;
  const [viewingCount, setViewingCount] = useState(viewingCountOnLoad);

  useEffect(() => {
    setViewingCount(viewingCountOnLoad);
  }, [searchCategory]);

  const handleLoadMore = async () => {
    document.activeElement instanceof HTMLElement &&
      document.activeElement.blur();
    const newViewingCount = ITEMS_PER_LOAD + viewingCount;
    loadMoreSearchResults("strain", newViewingCount);
    trackEvent(
      Category.searchResults,
      Action.searchResultClicked,
      "show more strain results button"
    );
    setViewingCount(newViewingCount);
  };

  if (!strains || !strains.length) return null;

  return (
    <>
      <h3 className="heading--l">Strains</h3>
      <div className="font-normal mb-lg">matching "{q}"</div>
      <div className="row mb-lg">
        {strains.slice(0, viewingCount).map((strain) => {
          return (
            <div
              className="col-6 md:col-1/2 lg:col-1/3 mb-md"
              key={strain.slug}
            >
              <StrainCard
                strain={strain}
                buyButtonLink={`/search/shop?shopCategory=strain&shopName=${encodeURIComponent(
                  strain.name
                )}`}
                buyButtonText="order online"
                elementType="a"
                className="h-full elevation-low"
                gtmAction={Action.searchResultClicked}
                gtmCategory={Category.searchResults}
              />
            </div>
          );
        })}
      </div>
      {strains.length >= viewingCount && (
        <button
          className="button mb-xxl"
          onClick={handleLoadMore}
          data-testid="strain-results-load-more"
        >
          show more strain results
        </button>
      )}
      <span className="heading--m font-bold">Shop by strain type</span>
      <PhenotypeCarousel asLink className="mt-lg" />
    </>
  );
};

export default StrainResults;
